import React, { useState, useEffect } from 'react';

// Este componente recibe:
// - isOpen: booleano para mostrar/ocultar
// - onClose: función para cerrar sin hacer nada
// - onConfirm: función que ejecuta la acción destructiva (borrar, cambiar precio)
// - title: Título del modal (ej: "¡Cuidado!")
// - message: Descripción de la acción
// - actionType: 'danger' (rojo) o 'warning' (amarillo)

const ModalSeguridad = ({ isOpen, onClose, onConfirm, title, message, actionType = 'danger' }) => {
  const [isChecked, setIsChecked] = useState(false);

  // Reseteamos el checkbox cada vez que se abre el modal
  useEffect(() => {
    if (isOpen) setIsChecked(false);
  }, [isOpen]);

  if (!isOpen) return null;

  // Colores dinámicos según el tipo de riesgo
  const colorClass = actionType === 'danger' ? 'bg-red-600 hover:bg-red-700' : 'bg-yellow-600 hover:bg-yellow-700';
  const borderClass = actionType === 'danger' ? 'border-red-200 bg-red-50' : 'border-yellow-200 bg-yellow-50';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-md p-6 transform transition-all scale-100">
        
        {/* Encabezado */}
        <div className={`flex items-center p-4 mb-4 rounded-md ${borderClass}`}>
          <div className="mr-3 text-2xl">⚠️</div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">{title}</h3>
            <p className="text-sm text-gray-600 mt-1">{message}</p>
          </div>
        </div>

        {/* Checkbox OBLIGATORIO */}
        <div className="mb-6 px-2">
          <label className="flex items-start cursor-pointer select-none">
            <div className="relative flex items-center">
              <input
                type="checkbox"
                className="w-5 h-5 border-2 border-gray-400 rounded focus:ring-red-500 text-red-600 cursor-pointer"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />
            </div>
            <span className="ml-3 text-sm font-medium text-gray-700">
              He notificado a mi superior sobre este cambio y asumo la responsabilidad.
            </span>
          </label>
        </div>

        {/* Botones de Acción */}
        <div className="flex justify-end gap-3 border-t pt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 font-medium transition-colors"
          >
            Cancelar
          </button>
          
          <button
            onClick={onConfirm}
            disabled={!isChecked}
            className={`px-4 py-2 text-white rounded-md font-bold shadow-md transition-all
              ${isChecked ? colorClass : 'bg-gray-300 cursor-not-allowed opacity-50'}
            `}
          >
            Confirmar Acción
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalSeguridad;